var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnPreloved(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.521 8.46a4.07 4.07 0 01-.326.287L8.37 13.838l-.039.033h.001a.515.515 0 01-.681 0l-.04-.033-5.805-5.093a4.286 4.286 0 01-.327-.285A4.978 4.978 0 01.002 5.036a4.998 4.998 0 011.296-3.503A4.667 4.667 0 014.61.005a4.648 4.648 0 013.386 1.342A4.653 4.653 0 0111.383.002a4.673 4.673 0 013.315 1.526 5.002 5.002 0 011.3 3.504 4.984 4.984 0 01-1.476 3.428z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

export default SvgIcnPreloved;